import PropTypes from "prop-types";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useExpertMessageReviewContext } from "../../../hooks/expert-message-review/ExpertMessageReviewContext";
import { validateMessageReview } from "../../../utils/validators/MessageReviewValidator";
const ExpertReviewSummary = ({
  children
}) => {
  const {
    messageReviewDetails,
    submitReviewData
  } = useExpertMessageReviewContext();
  const log = pilog.getLogger("ExpertReviewSummary");
  log.debug(messageReviewDetails);
  const handleReviewCompleted = () => {
    submitReviewData();
  };
  const {
    isCancelDisabled,
    isFinishDisabled
  } = validateMessageReview(messageReviewDetails);
  return children({
    messageReviewDetails,
    isCancelDisabled,
    isFinishDisabled,
    noOfDialoguesVoted: Object.keys(messageReviewDetails.dialogues).length,
    onFormSubmit: handleReviewCompleted
  });
};
export default ExpertReviewSummary;
ExpertReviewSummary.propTypes = {
  children: PropTypes.func.isRequired
};